import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import PermissionsService from '@rootCommon/services/permissions-service';
import * as actions from '@actions/tabs-access';
import { PermissionsUserAccessResponse } from '@rootCommon/types/permission-access';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

function* getAdminTabsAccessAsync() {
  try {
    const res: PermissionsUserAccessResponse = yield call(PermissionsService.getUserAccess);
    yield put(actions.getAdminTabsAccess.success(res));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.getAdminTabsAccess.failure(error));
  }
}

function* watchGetTabsAccess() {
  yield takeLatest(actions.getAdminTabsAccess.request, getAdminTabsAccessAsync);
}

export default function* watchTabsAccess(): SagaGenerator {
  yield all([watchGetTabsAccess()]);
}
